import { Home } from '../pages/Home';
import { Page404 } from '../pages/Page404';
// import { TeikiHoan } from '../pages/home/TeikiHoan';
import { JWTError } from '../pages/JWTError';
import { InputMail } from '../pages/InputMail';
import { InputResevationNo } from '../pages/InputResevationNo';
import { SelectMenu } from '../pages/SelectMenu';

export const homeRoutes = [
  {
    path: '/',
    element: <Home />,
    exact: true,
  },
  {
    path: '/JWTError',
    element: <JWTError />,
  },
  {
    path: '/mail',
    element: <InputMail />,
  },
  {
    path: '/resevation',
    element: <InputResevationNo />,
  },

  {
    path: '/menu',
    element: <SelectMenu />,
  },

  {
    path: '*',
    element: <Page404 />,
  },
];
